"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EducationalDropdown;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _flyout = _interopRequireDefault(require("@ux/flyout"));
var _icon = require("@site/pattern-library-utils/icon");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _image = require("@site/pattern-library-core/image");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _tracking = _interopRequireDefault(require("@site/pattern-library-utils/tracking"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _layers = require("@site/pattern-library-utils/layers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const flyoutClass = "core-f1ezl52b";
const flyoutClassElevated = "core-fxr05yu";
const dropdownContainerClass = "core-d91j184";
const suggestionsSectionClass = "core-s1vvxohg";
const listClass = "core-l1f119p5";
const itemClass = "core-i1j8cufg";
const suggestionButtonClass = "core-s1420u69";
const rightContentClass = "core-r1jhdz73";
const cardContainerClass = "core-c64pmag";
const cardTitleContainerClass = "core-c1ljgxkh";
const iconContainerClass = "core-ilprb3d";
const sparklesBackgroundClass = "core-slk3odg";
const imageContainerClass = "core-i8i0dx3";
function SuggestionButton({
  value,
  trackingName,
  isPromo,
  trackingCustomProperties,
  onClick,
  className,
  ariaLabel
}) {
  const trackingProps = _tracking.default.create(trackingName, true, isPromo, trackingCustomProperties);
  return /*#__PURE__*/_react.default.createElement(_text.default.button, (0, _extends2.default)({
    as: "action",
    size: 1,
    className: className,
    onClick: onClick,
    "aria-label": ariaLabel || `Select domain suggestion ${value}`
  }, trackingProps), value);
}
SuggestionButton.propTypes = {
  value: _propTypes.default.string.isRequired,
  trackingName: _propTypes.default.string.isRequired,
  isPromo: _propTypes.default.bool,
  trackingCustomProperties: _propTypes.default.object,
  onClick: _propTypes.default.func,
  className: _propTypes.default.string,
  ariaLabel: _propTypes.default.string
};

/**
 * EducationalDropdown component.
 *
 * @param {Object} props React props
 * @param {string} props.id Unique identifier for the dropdown flyout
 * @param {string[]} props.items Array of suggestion strings to display
 * @param {boolean} props.open Whether the dropdown is open
 * @param {Function} props.onSelect Callback when a suggestion is selected
 * @param {Object} props.parentRef Reference to the parent element for positioning
 * @param {Function} props.onClose Callback when the dropdown is closed
 * @param {Object[]} props.contentCards Array of content cards to display
 * @param {string} props.contentCards[].icon Icon name for the card
 * @param {string} props.contentCards[].title Title text for the card
 * @param {string} props.contentCards[].description Description text for the card
 * @param {Object} [props.contentCards[].image] Image object with url, height, width, altText properties
 * @param {string} [props.contentCards[].imageUrl] Direct image URL as fallback when image object is not available for .gif
 * @param {string} props._name Sitecore item name for tracking
 * @param {boolean} props.isPromo Use promo (default) or eid for tracking
 * @param {Object} props.trackingCustomProperties Custom properties object for tracking
 * @param {boolean} props.isOnOverlay Whether the dropdown is on an overlay
 * @returns {React.ReactElement} EducationalDropdown component
 * @public
 */
function EducationalDropdown({
  id = 'domain-suggestions-flyout',
  items = [],
  open = false,
  onSelect,
  parentRef,
  onClose,
  contentCards = [],
  _name,
  isPromo = true,
  trackingCustomProperties = {},
  isOnOverlay = false
}) {
  const contentRef = (0, _react.useRef)(null);
  const [anchorWidth, setAnchorWidth] = (0, _react.useState)();
  const containerInlineStyle = anchorWidth ? {
    width: `${anchorWidth}px`
  } : {};

  // Keep flyout width in sync with domain search
  (0, _react.useEffect)(() => {
    const updateWidthFromAnchor = () => {
      if (parentRef?.current) {
        const {
          width
        } = parentRef.current.getBoundingClientRect();
        setAnchorWidth(width);
      }
    };
    updateWidthFromAnchor();
    let resizeObserver;
    if (typeof window !== 'undefined' && 'ResizeObserver' in window && parentRef?.current) {
      resizeObserver = new window.ResizeObserver(updateWidthFromAnchor);
      resizeObserver.observe(parentRef.current);
    } else {
      window?.addEventListener?.('resize', updateWidthFromAnchor);
    }
    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      } else {
        window?.removeEventListener?.('resize', updateWidthFromAnchor);
      }
    };
  }, [parentRef, open]);
  const suggestionsContent = /*#__PURE__*/_react.default.createElement("div", {
    className: suggestionsSectionClass
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: listClass
  }, items.length > 0 ? items.map((value, index) => /*#__PURE__*/_react.default.createElement("li", {
    key: `${value}-${index}`,
    className: itemClass,
    role: "option",
    "aria-selected": false
  }, /*#__PURE__*/_react.default.createElement(SuggestionButton, {
    value: value,
    trackingName: `${_name}_suggestion_${value}`,
    isPromo: isPromo,
    trackingCustomProperties: trackingCustomProperties,
    onClick: () => onSelect && onSelect(value),
    className: suggestionButtonClass,
    ariaLabel: `Select domain suggestion ${value}`
  }))) : null));
  const rightContent = contentCards?.length ? /*#__PURE__*/_react.default.createElement("div", {
    className: rightContentClass
  }, contentCards.map((card, index) => {
    const {
      icon,
      title,
      description,
      image,
      imageUrl
    } = card;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: `content-card-${index}`,
      className: cardContainerClass
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cardTitleContainerClass
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _core.cx)(iconContainerClass, icon === 'sparkles-filled' && sparklesBackgroundClass),
      "data-partial": "dark1"
    }, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: icon
    })), /*#__PURE__*/_react.default.createElement(_text.default.p, {
      as: "title",
      size: 1
    }, title)), /*#__PURE__*/_react.default.createElement("div", {
      className: "card-description-container"
    }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
      as: "paragraph",
      size: -1
    }, description)), /*#__PURE__*/_react.default.createElement("div", {
      className: imageContainerClass
    }, (image || imageUrl) && /*#__PURE__*/_react.default.createElement(_image.LazyImage, {
      url: image?.url || imageUrl,
      height: image?.height,
      width: image?.width,
      altText: image?.altText || title
    })));
  })) : null;
  if (items.length === 0 || !open) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_flyout.default, {
    id: id,
    anchorRef: parentRef,
    placement: "bottom-start",
    strategy: "fixed",
    portalElem: document.body,
    onClose: onClose,
    className: (0, _core.cx)(flyoutClass, isOnOverlay && flyoutClassElevated)
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: contentRef,
    role: "listbox",
    "data-cy": "domain-suggestions-flyout",
    className: (0, _core.cx)(dropdownContainerClass, 'suggestions-flyout'),
    style: containerInlineStyle
  }, suggestionsContent, rightContent));
}
EducationalDropdown.propTypes = {
  items: _propTypes.default.arrayOf(_propTypes.default.string),
  open: _propTypes.default.bool,
  onSelect: _propTypes.default.func,
  id: _propTypes.default.string,
  parentRef: _propTypes.default.object,
  onClose: _propTypes.default.func,
  contentCards: _propTypes.default.arrayOf(_propTypes.default.shape({
    icon: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired,
    description: _propTypes.default.string.isRequired,
    image: _propTypes.default.shape(_image.imgPropShape),
    imageUrl: _propTypes.default.string
  })),
  _name: _propTypes.default.string,
  isPromo: _propTypes.default.bool,
  trackingCustomProperties: _propTypes.default.object,
  isOnOverlay: _propTypes.default.bool
};